import { PATH_PRIVATE_AREA, PRIVATE_AREA_TYPES } from "./constants";

export const TYPE_BEHAVIOR = "behavior";
export const TYPE_MANAGEMENTS = "managments";
export const TYPE_COMMUNICATION = "comunications";
export const TYPE_COMMERCIAL = "commercial";
export const TYPE_RENEWAL_R2R = "renewal-R2R";
export const TYPE_PERSONAL_ADVANTAGE_R2R = "personal-advantage-R2R";
export const TYPE_EXTRA_EXPENSE = "extra-expense";
export const TYPE_ORDER_COMPLETED = "order-completed";
export const TYPE_NOT_ORDER_COMPLETED = "not-order-completed";
export const TYPE_BD_COMPLETED = "bd-completed";
export const TYPE_NOT_BD_COMPLETED = "not-bd-completed";
export const TYPE_PENDING_BD_COMPLETED = "pending-bd-completed";
export const DEBT_PAYMENT = "debt-payment";
export const CLAIM_OPEN = "claim-open";
export const CLAIM_END = "claim-end";
export const MODEL_347 = "model-347";
export const TYPE_ONE_BILL = "one-bill";
export const TYPE_BILLS = "bills";
export const TYPE_PROMOTION = "promo";
export const TYPE_CITA_PREVIA_INSTALADOR = "cita-previa-instalador";
export const TYPE_CITA_PREVIA_TECNICO = "cita-previa-tecnico";
export const TYPE_PREPAID_BALANCE = "prepaid-balance";
export const TYPE_PREPAID_RENEW = "prepaid-renew";
export const TYPE_PREPAID_INSUFFICIENT_DATA = "prepaid-insuficient-data";
export const TYPE_DOWNLOAD_ESIM = "esim-download";
export const TYPE_PENDING_ESIM = "esim-pending";
export const TYPE_ACTIVATE_DISNEY = "activate-disney";
export const TYPE_ACTIVATE_MOVISTAR_PLUS = "activate-movistar-plus";
export const BLOCKING_FOR_THEFT = "blocking-for-theft";

export const NOTIFICATIONS = [
  // GASTO EXTRA
  {
    text: "Tienes un gasto extra",
    icon: "informacion-m",
    color: "orange",
    link: "/area-cliente/mis-productos/consumos/gasto-extra?period=0",
    order: 1,
    type: ["behavior", "extra-expense"],
    pages: [
      "mis-productos",
      "linea-fija",
      "internet",
      "linea-movil",
    ],
  },
  // PEDIDOS
  {
    text : "",
    text1: "Tienes un pedido en curso",
    text2: "Tienes pedidos en curso",
    icon: "envio-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/",
    linkToDetail:
      "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/detalle",
    order: 2,
    type: ["managments", "not-order-completed"],
    pages: ["mis-productos", "gestiones"],
  },
  {
    text : "",
    text1: "Tienes un pedido finalizado",
    text2: "Tienes pedidos finalizados",
    icon: "envio-m",
    color: "green",
    link: "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/",
    linkToDetail:
      "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/detalle",
    order: 4,
    type: ["managments", "order-completed"],
    pages: ["mis-productos", "gestiones"],
  },
  {
    text: "Selecciona cita para la visita del instalador",
    text2: "Tienes una cita con un instalador",
    icon: "calendario-mes-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/mi-perfil/cita-previa/",
    linkToDetail: "https://www.movistar.es/area-cliente/mi-perfil/cita-previa/",
    order: 4,
    type: ["cita-previa-instalador"],
    pages: ["mis-productos", "gestiones"],
  },
  // AVERÍAS
  {
    text: "Estamos trabajando en tu avería",
    textPaused: "Tienes una avería en pausa",
    icon: "soporte-tecnico-m",
    color: "movistarBlue",
    link: "/area-cliente/soporte/averia/",
    linkToDetail: "/area-cliente/soporte/averia/",
    onClick: null,
    order: 3,
    type: ["managments", "not-bd-completed"],
    pages: ["mis-productos", "gestiones", "soporte"],
  },
  {
    text: "Hemos resuelto tu avería",
    icon: "soporte-tecnico-m",
    color: "movistarBlue",
    link: "/area-cliente/soporte/averia/",
    linkToDetail: "/area-cliente/soporte/averia/",
    onClick: null,
    order: 4,
    type: ["managments", "pending-bd-completed"],
    pages: ["mis-productos", "gestiones", "soporte"],
  },
  {
    text: "Hemos resuelto tu avería",
    icon: "soporte-tecnico-m",
    color: "green",
    link: "/area-cliente/soporte/averia/",
    linkToDetail: "/area-cliente/soporte/averia/",
    onClick: null,
    order: 5,
    type: ["managments", "bd-completed"],
    pages: ["mis-productos", "gestiones", "soporte"],
  },
  {
    text: "Selecciona cita para la visita del técnico",
    text2: "Tienes una cita con un técnico",
    icon: "calendario-mes-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/mi-perfil/cita-previa/",
    linkToDetail: "https://www.movistar.es/area-cliente/mi-perfil/cita-previa/",
    order: 4,
    type: ["cita-previa-tecnico"],
    pages: ["mis-productos", "gestiones", "soporte"],
  },
  // RECLAMACION FACTURAS
  {
    text: "Estamos analizando tu reclamación",
    icon: "email-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/facturas/reclamaciones",
    order: 6,
    type: ["claim-open"],
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Hemos resuelto tu reclamación",
    icon: "email-m",
    color: "green",
    link: "https://www.movistar.es/area-cliente/facturas/reclamaciones",
    order: 7,
    type: ["claim-end"],
    pages: ["mis-productos", "facturas"],
  },
  // FACTURAS
  {
    text: "Ya tienes la factura disponible",
    icon: "euro-circulo-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/facturas",
    order: 8,
    type: ["comunications", "one-bill"],
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Ya tienes las facturas disponibles",
    icon: "euro-circulo-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/area-cliente/facturas/listado-facturas/",
    order: 9,
    type: ["comunications", "bills"],
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Fecha de cargo de la factura: ",
    icon: "euro-circulo-m",
    color: "movistarBlue",
    link: "",
    order: 11,
    type: "comunications",
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Tienes facturas pendientes",
    icon: "informacion-m",
    color: "orange",
    link: "https://www.movistar.es/cliente/areaprivada/#/debtPayment",
    order: 10,
    type: ["comunications", "debt-payment"],
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Modelo 347 ya disponible. Llama al 1004",
    icon: "documento-m",
    color: "movistarBlue",
    link: "",
    order: 12,
    type: ["comunications", "model-347"],
    pages: ["mis-productos", "facturas"],
  },
  // COMERCIALES
  {
    text: "Tu ventaja personal:",
    icon: "navidad-regalo-m",
    color: "movistarBlue",
    link: "https://www.movistar.es/moviles/",
    order: -1,
    type: ["commercial", "personal-advantage-R2R"],
    pages: ["mis-productos"],
  },
  {
    text: "Tu promoción acaba el",
    icon: "informacion-m",
    color: "movistarBlue",
    link: "",
    order: 13,
    type: ["commercial", "promo"],
    pages: ["mis-productos"],
  },
  {
    text: "Cambio de las condiciones del contrato",
    icon: "informacion-m",
    color: "orange",
    link: "",
    order: 14,
    type: "commercial",
    pages: ["mis-productos"],
  },
  {
    text: "Hemos subido la velocidad de tu fibra",
    icon: "informacion-m",
    color: "movistarBlue",
    link: "",
    order: 15,
    type: "commercial",
    pages: ["mis-productos"],
  },
  {
    text: "Renueva tu",
    icon: "informacion-m",
    color: "orange",
    link: "https://www.movistar.es/moviles/?customTags=renovacion",
    target: "_blank",
    order: 0,
    type: "renewal-R2R",
    pages: ["mis-productos"],
  },
  //PREPAGO
  {
    text: "El saldo de tu línea Prepago es inferior a 2€",
    icon: "informacion-m",
    color: "orange",
    link: "",
    linkToDetail:
      "/area-cliente/gestiones/linea-movil?launch-recargar-modal=true",
    order: 16,
    type: "prepaid-balance",
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "No tienes saldo suficiente para renovar tu tarifa",
    icon: "informacion-m",
    color: "movistarBlue",
    link: "",
    linkToDetail:
      "/area-cliente/gestiones/linea-movil?launch-recargar-modal=true",
    order: 17,
    type: "prepaid-renew",
    pages: ["mis-productos", "facturas"],
  },
  {
    text: "Añade datos a tu tarifa",
    icon: "informacion-m",
    color: "movistarBlue",
    link: "",
    linkToDetail: "/area-cliente/mis-productos/consumos",
    order: 17,
    type: "prepaid-insuficient-data",
    pages: ["mis-productos", "facturas"],
  },
  //ESIM
  {
    text: "Ya puedes instalar tu eSIM",
    icon: "informacion-m",
    color: "orange",
    link: "/area-cliente/gestiones/linea-movil/e-sim/",
    linkToDetail: "/area-cliente/gestiones/linea-movil/e-sim/",
    order: 17,
    type: "esim-download",
    pages: ["mis-productos", "gestiones", "linea-movil"],
  },
  //ESIM pendiente descarga
  {
    text: "Estamos configurando tu eSIM",
    icon: "informacion-m",
    color: "orange",
    link: "/area-cliente/gestiones/linea-movil/e-sim/?status=en-curso",
    linkToDetail: "/area-cliente/gestiones/linea-movil/e-sim/?status=en-curso",
    order: 16,
    type: "esim-pending",
    pages: ["mis-productos", "gestiones", "linea-movil"],
  // RESTRICCIONES
  },
  {
    text: "Tu línea {phone} está bloqueada",
    icon: "candado-m",
    color: "orange",
    link: "https://www.movistar.es/area-cliente/gestiones/linea-movil/detalle?productId={productId}&serviceId=bloqueos-robo",
    order: 10,
    type: "blocking-for-theft",
    pages: ["linea-movil"],
  },
  //ACTIVAR DISNEY
  {
    text: "Crea tu cuenta de Disney+",
    icon: "informacion-m",
    color: "orange",
    link: "/area-cliente/mis-productos/tv/activacion/?provider=disney",
    order: 18,
    type: "activate-disney",
    pages: ["mis-productos"],
  },
  //ACTIVAR MOVISTAR PLUS
  {
    text: "Crea tu cuenta de Movistar Plus",
    icon: "informacion-m",
    color: "orange",
    link: "/area-cliente/mis-productos/tv/activacion/?provider=disney",
    order: 18,
    type: "activate-movistar-plus",
    pages: ["mis-productos"],
  },
];
